import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FormInput, ActionWithPlus, ProjectListHeader } from '../../../components'
import { back, push } from '../../../actions/nav-actions'
import { fetchActivities, putActivities, removeActivity } from '../../../api';
import { notify, getDictionary } from '../../../utils'

class EvaluateContext extends Component {
  state = {
    project: {},
    is_loading: false,
    error: undefined,
    data: {}
  }
  constructor(props) {
    super(props);
    this.request = this.request.bind(this);
    this.getParams = this.getParams.bind(this);
    this.client = getDictionary(props.dictionary);
    this.getText = this.getText.bind(this);
    this.deleteActivity = this.deleteActivity.bind(this);
  }
  getText(tag, category = 'activities') {
    return this.client.get(category, tag);
  }
  getParams() {
    return this.props.match.params || {};
  }
  deleteActivity(activity) {
    removeActivity(
      this.props.user.token,
      this.props.match.params.organization,
      this.props.match.params.code,
      activity._id
    ).then((data) => {
      this.setState({ is_loading: false, data });
    }).catch(err => {
      alert(err.message);
    })
  }
  componentDidMount() {
    const params = this.getParams();
    this.setState({ is_loading: true, error: undefined }, () => {
      fetchActivities(this.props.user.token,
        params.organization,
        params.code
      )
        .then((data) => this.setState({ is_loading: false, data }))
        .catch(err => this.setState({ is_loading: false, error: err }))
    });
  }
  request() {
    const params = this.getParams();
    putActivities(
      this.props.user.token,
      params.organization,
      params.code,
      {
        ...this.state.data
      }
    )
      .then((data) => notify("Update informations", "Successfully updated!"))
      .catch((err) => notify('Error', err.message, 'error'))
  }
  render() {
    if (this.state.error) return <span>{this.state.error.message}</span>
    if (!this.state.data.activities || this.state.is_loading) return <span>Loading data...</span>
    let { activities, options, questions } = this.state.data;
    return (
      <React.Fragment>
        <div>
          <p>{this.getText('description')}</p>
          <div>
            {options.activities.map((activity, index) => {
              return (
                <div key={index}>
                  <p>{activity.name}</p>
                  <FormInput
                    value={activity.name}
                    onChange={(text) => {
                      let { options } = this.state.data;
                      options.activities[index].name = text;
                      this.setState({
                        data: {
                          ...this.state.data,
                          options
                        }
                      });
                    }}
                    placeholder="" />
                  <p>Description</p>
                  <FormInput
                    value={activity.value}
                    onChange={(text) => {
                      let { options } = this.state.data;
                      options.activities[index].value = text;
                      this.setState({
                        data: {
                          ...this.state.data,
                          options
                        }
                      });
                    }}
                    placeholder="" />

                  <p>Progress</p>
                  <FormInput
                    style={{ marginTop: 16 }}
                    value={options.activities[index].progress[0]}
                    onChange={(text) => {
                      let { options } = this.state.data;
                      options.activities[index].progress[0] = text;
                      this.setState({
                        data: {
                          ...this.state.data,
                          options
                        }
                      });
                    }}
                    placeholder="Write your new progress state here" />

                  <a href="#" style={{ color: '#C51E48' }} onClick={(event) => {
                    event.preventDefault();
                    let response = window.confirm("You really sure about delete this activity?");
                    if (response) {
                      this.deleteActivity(activity);
                    }
                  }}>Remove Activity {options.activities[index].name}</a>
                  <br /><br /><br />
                </div>
              )
            })}
            <ActionWithPlus
              style={{ marginTop: 24 }}
              onClick={() => {
                this.props.push(`/projects/${this.props.match.params.organization}/${this.props.match.params.code}/activities#activities`)
              }}
              label="Add activity" />

          </div>
        </div>

        <ProjectListHeader title="QUESTION TO CONSIDER" />
        <div>
          <p>Answer the following questions.</p>
          <p>{this.getText('convene_question')}</p>

          <FormInput
            value={activities.questions.convene}
            onChange={(text) => {
              let { activities } = this.state.data;
              activities.questions.convene = text;
              this.setState({
                data: {
                  ...this.state.data,
                  activities
                }
              });
            }}
            placeholder="" />

          <p>{this.getText('achieving_goals_question')}</p>
          <FormInput
            value={activities.questions.achieving_goals}
            onChange={(text) => {
              let { activities } = this.state.data;
              activities.questions.achieving_goals = text;
              this.setState({
                data: {
                  ...this.state.data,
                  activities
                }
              });
            }}
            placeholder="" />

          <p>{this.getText('milestones_question')}</p>
          <FormInput
            value={activities.questions.milestones}
            onChange={(text) => {
              let { activities } = this.state.data;
              activities.questions.milestones = text;
              this.setState({
                data: {
                  ...this.state.data,
                  activities
                }
              });
            }}
            placeholder="" />

          <div>
            {questions.map((question, index) => {
              return (
                <div key={index}>
                  <p>Question:</p>
                  <FormInput
                    value={question.description}
                    onChange={(value) => {
                      let { questions } = this.state.data;
                      questions[index].description = value;
                      this.setState({
                        data: {
                          ...this.state.data,
                          questions
                        }
                      });
                    }}
                    placeholder="" />
                  <p>Answer:</p>
                  <FormInput
                    value={question.value}
                    onChange={(value) => {
                      let { questions } = this.state.data;
                      questions[index].value = value;
                      this.setState({
                        data: {
                          ...this.state.data,
                          questions
                        }
                      });
                    }}
                    placeholder="" />
                </div>
              )
            })}
          </div>

          <ActionWithPlus
            style={{ marginTop: 16 }}
            onClick={() => {
              this.props.push(`/projects/${this.props.match.params.organization}/${this.props.match.params.code}/questions/activities#activities`)
            }}
            label="Add question" />
        </div>

        <button
          className="btn btn-info"
          onClick={this.request.bind(this)}
          style={{ marginTop: 24, marginBottom: 24 }}>
          SAVE
        </button>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({ ...state.localStorage, user: state.authReducer.user });

const mapDispatchToProps = dispatch => ({
  back() {
    dispatch(back())
  },
  push(routeName) {
    dispatch(push(routeName))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(EvaluateContext);


// WEBPACK FOOTER //
// ./src/routers/Projects/Formularies/ActivitiesFormularies.js